import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { SHIMMER_KEYFRAMES, shimmerAfterSx } from './skeletonShimmer';

interface MediaTileSkeletonProps {
  /** Position within the batch, used to stagger shimmer + entrance. */
  index?: number;
  /** Load-more batches animate quieter so they don't compete with real tiles. */
  quiet?: boolean;
}

const MediaTileSkeleton: React.FC<MediaTileSkeletonProps> = ({ index = 0, quiet = false }) => {
  const delay = Math.min((index % 16) * 0.05, quiet ? 0.3 : 0.5);

  return (
    <Box
      component={motion.div}
      aria-hidden
      initial={{ opacity: 0 }}
      animate={{ opacity: quiet ? 0.7 : 1 }}
      transition={{ duration: 0.3, ease: 'easeOut', delay: delay * 0.4 }}
      sx={{
        position: 'relative',
        aspectRatio: '1 / 1',
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid #2F3336',
        backgroundColor: '#0F1419',
        ...SHIMMER_KEYFRAMES,
        '&::after': shimmerAfterSx(delay, quiet),
      }}
    >
      {/* Type chip placeholder */}
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          left: 8,
          width: 40,
          height: 20,
          borderRadius: 1,
          backgroundColor: '#2F3336',
          opacity: 0.25,
        }}
      />
      {/* Download control placeholder */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 8,
          right: 8,
          width: 28,
          height: 28,
          borderRadius: '50%',
          backgroundColor: '#2F3336',
          opacity: 0.2,
        }}
      />
    </Box>
  );
};

export default MediaTileSkeleton;
